import md5 from 'js-md5'
// 前端请求必加内容
export function frontHeater([...key], [...val]) {
    // 获取当前毫秒为主的时间戳
    let timeStamp = new Date().getTime(getCurrentTime())
    // 获取加密串
    let secret = "cms";
    let secretKey = "crb_2021@#"
    let str = "secret_time"
    let parameterKey = [...key];
    let parameterValue = [...val];
    let user_data = {};
    parameterKey.map((val, index) => {
        Object.assign(user_data, { [parameterKey[index]]: parameterValue[index] })
    })

    var strString = [];
    for (var p in user_data)
        if (user_data.hasOwnProperty(p)) {
            strString.push(encodeURIComponent(p) + "" + encodeURIComponent(user_data[p]));
        }
    let keyvalue = strString.join("");


    let list = str + timeStamp + keyvalue + secretKey;
    let encryptionString = md5(list);
    let obj = { timeStamp, encryptionString, parameterKey, secret };
    return obj
}


// 获取毫秒时间
export function getCurrentTime() {
    let time;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth() + 1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
    let ms = new Date().getMilliseconds() < 100 ? (('0' + new Date().getMilliseconds()) < 10 ? '00' + new Date().getMilliseconds() : '0' + new Date().getMilliseconds()) : new Date().getMilliseconds();
    time = yy + '/' + mm + '/' + dd + ' ' + hh + ':' + mf + ':' + ss + ':' + ms;

}
